import React, { useState } from "react";
import { AppHeader } from "../../components";
import { PatientsData } from "./components";

export default function PatientsListPage() {
  const [searchVal, setSearchVal] = useState("");

  return (
    <>
      <AppHeader searchVal={searchVal} setSearchVal={setSearchVal} />
      <PatientsData searchVal={searchVal} setSearchVal={setSearchVal} />
    </>
  );
}
